import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

const VatRateDropdown = (props: DropdownProps<server.dto.VatRate>) => {
  return <BaseReactSelectDropdown
    excludeKeys={[]}
    options={props.options}
    getLabel={vat => `${vat.internalName} (${vat.percentageFormatted})`}
    getValue={(t) => t.vatRateId}
    value={props.value}
    onChange={props.onChange}
    config={props.config}
  />;
};

export default VatRateDropdown;